export function MetricStrip({ children, className = "", columns = 4, busy = false }) {
  return (
    <section
      className={`ds-metric-strip${className ? ` ${className}` : ""}`}
      style={{ "--ds-metric-columns": columns }}
      aria-busy={busy || undefined}
    >
      {children}
    </section>
  );
}

export function MetricItem({ label, value, meta, tone = "neutral", className = "" }) {
  return (
    <article className={`ds-metric-item ds-metric-item--${tone}${className ? ` ${className}` : ""}`}>
      <span className="ds-metric-item__label">{label}</span>
      <strong className="ds-metric-item__value">{value}</strong>
      {meta ? <span className="ds-metric-item__meta">{meta}</span> : null}
    </article>
  );
}
